   <template>

    <div class="">

      <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-large
        rounded="sm"
        style="height:100vh"
        variant="dark"
        id="loader"
      >


      <b-container fluid style="padding-top: 100px;text-align:left">
          <b-row>
            <b-col cols="12 headerF"><HeaderConsumer/></b-col>
            <b-col cols="12 headerM"><HeaderConsumerMobile/></b-col>
          </b-row>

           <br>
          <b-row>
            <b-col cols="12">
              <div>
                <b-tabs content-class="mt-3" justified active>
                  <b-tab title="Update Profile" @click ="showConsDetails('click')">
                    <b-card
                     title="Update Profile"
                     style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                     class="mb-2"
                     >
                     <b-row style="padding-bottom:0px;text-align:center">
                       <b-col cols=12>
                         Consumer No: <select class="customSelect" id="consList5" @change="showConsDetails('change')"> </select>
                       </b-col>
                     </b-row>
                     <hr/>
                              <b-row>
                                <b-col col cols="6" sm="6" md="6" lg="2">
                                    <span class="label">Consumer Number : </span>
                                </b-col>
                                <b-col col cols="6" sm="6" md="6" lg="3">
                                  <span id="consumerNumber" > </span>
                                </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="2" class="marginTop20px">
                                  <span class="label">Consumer Name : </span>
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                                <span id="consumerName"></span>
                              </b-col>
                            </b-row>

                          </br>
                            <b-row>
                              <b-col col cols="6" sm="6" md="6" lg="2" class="label" >
                                  Mobile No <span class="text-danger">*</span> :
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="3">
                                  <b-form-input type="text" id="mobile" maxlength="10" autocomplete="off"  placeholder="Enter Mobile No" value="" trim >
                                  </b-form-input>
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="2" class="label marginTop20px">
                                  Email ID:
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                                 <b-form-input type="email" id="email" autocomplete="off"  placeholder="Enter Email ID " value="" trim >
                                  </b-form-input>
                              </b-col>
                            </b-row>
                            <br>
                            <b-row>
                              <b-col col cols="6" sm="6" md="6" lg="2" class="label ">
                                  Occupation <span class="text-danger">*</span> :
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="3">
                                <b-form-select id="occupation" class="mb-3" v-model="selected">
                                   <b-form-select-option value="null" >Please select an option</b-form-select-option>
                                   <b-form-select-option value="Govt">Govt Employee</b-form-select-option>
                                   <b-form-select-option value="SemiGovt">Semi Govt Employee</b-form-select-option>
                                   <b-form-select-option value="PSU">PSU Employee</b-form-select-option>
                                   <b-form-select-option value="Others">Others</b-form-select-option>
                                 </b-form-select>
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="2" class="label marginTop20px">
                                 Aadhaar No </span> :
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                                <b-form-input type="text" maxlength="12" id="aadhaar"  placeholder="Enter Aadhar No" trim  >
                                 </b-form-input>
                              </b-col>

                            </b-row>
                            <br>
                            <br>
                            <b-row>
                            <b-col col cols="6" sm="3" md="3" lg="3" offset="3" offset-sm="4" offset-md="4" offset-lg="4">
                                <b-button id="updateButton" @click="sendOtp()" block squared variant="primary">
                                  UPDATE</b-button>
                                 <br>
                            </b-col>
                          </b-row>
                        </b-card>
                  </b-tab>
                  <b-tab title="Online Payment" @click="showBill()">
                    <b-card no-body class="mb-2 OnlinePaymentCardStyle">
                     <div id="consBillDiv">
                        <b-row>
                          <b-col cols=10 offset=1   style="margin-top:10px;text-align:center;font-size:1em">
                            Consumer No
                          </b-col>
                            <b-col cols=10 offset=1 style="text-align:center;" >
                            <!-- <b-form-select  :options="consList" size="sm" class="mt-3" style="text-align:center;"></b-form-select> -->
                            <select class="customSelect" id="consList1" @change="showBill()">
                            </select>
                            <input id="sdCode" hidden />
                          </b-col>
                        </b-row>

                    <div id="msgDiv" style="color:#f4511e ;font-weight:600;display:none" >
                          <br>
                          <span class="data" id="msg" style="padding:10px" ></span>
                        </br>
                    </div>
                        <br>
                    <div id="billDiv" style="display:none">
                      <b-row>
                         <b-col cols=10 offset=1 style="background-color:#ffff;text-align:center">
                         <b-iconstack font-scale="5" animation="spin">
                            <b-icon stacked icon="circle-fill" variant="secondary"></b-icon>
                            <b-icon stacked icon="receipt" scale="0.5" variant="light"></b-icon>
                         </b-iconstack>
                         </b-col>
                       </b-row>
                     <br>
                     <b-row>
                        <b-col cols=10 offset=1 style=";text-align:center;color:#757575 ;">
                          Bill Amount<br>
                          <span id="billAmt" style="letter-spacing:1px;font-size:2.5rem;color:#0277bd;font-weight:900"></span>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols=10 offset=1 style="text-align:center;color:#757575 ;">
                          Due Date<br>
                          <span id="dueDate" style="letter-spacing:1px;font-size:1.2rem;color:#f4511e;font-weight:700"></span>
                        </b-col>
                      </b-row>
                      <br>
                      <b-row>
                        <b-col cols=12>
                          <!-- <p style="color:red;padding:10px;font-size:1rem">
                          We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.
                        </p> -->
                           <b-button block squared variant="primary" @click="payNow()" style="width:100%;padding: 15px;margin-bottom: -1px;border-radius: 0 0 5px 5px !important;">
                            PAY NOW
                          </b-button>
                        </b-col>
                     </b-row>
                   </div>
                 </div>
                   <div id="billdeskRequestDiv" fluid style="padding-top: 10px;text-align:left;display:none">
                     <b-row id="spinner" style="display:block">
                     <b-col cols=12 align="center">
                       <h3 class="">Processing Payment Request...</h3>
                       <br><br>
                         <b-spinner style="width: 10rem; height: 10rem;" variant="primary" label="Spinning"></b-spinner>
                       <br><br><br>
                      <h5 style="color:red">Please do not press back or refresh button</h5>
                   </b-col>
                   </b-row>
                   <b-row id="errorDiv" style="display:none">
                     <b-col cols=12 align="center">
                       <h2 style="color:red">ERROR : transaction is already processed.</h2>
                       <br><br>
                       <b-button>Go Back</b-button>
                     </b-col>
                   </b-row>
                 </div>

                 <form :action = "reqUrl" method="post" id="pgrequest" hidden>
                     <input type="" name="msg" :value = "messageToSend" hidden >
                     <input type="submit" id="submit" value="submit" hidden>
                 </form>

                   </b-card>
                 </b-tab>



                 <b-tab title="Billing History" @click="getBillHistory('click')">
                   <b-card
                    title="Consumer Bill Details"
                    style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                    class="mb-2"
                    >
                    <b-row style="padding-bottom:10px;text-align:center">
                      <b-col cols=12>
                        Consumer No: <select class="customSelect" id="consList2" @change="getBillHistory('change')"> </select>
                      </b-col>
                    </b-row>

                     <b-table  responsive  :items="consumerBill" :fields="consumerBillFields">
                         <template v-slot:cell(due_amt)="data">
                           <span   v-html="data.value"></span>
                        </template>
                        <template v-slot:cell(net_amt)="data">
                          <span   v-html="data.value"></span>
                       </template>
                       <template   v-slot:cell(link)="data">
                         <span  v-html="data.value"></span>
                      </template>
                     </b-table>
                  </b-card>
                </b-tab>

                <b-tab title="Payment History" @click="getPaymentHistory('click')" >
                  <b-card
                   title="Online Payment History"
                   style="   box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                   class="mb-2"
                   >
                   <b-row style="padding-bottom:10px;text-align:center">
                     <b-col cols=12>
                       Consumer No: <select class="customSelect" id="consList3" @change="getPaymentHistory('change')"> </select>
                     </b-col>
                   </b-row>

                    <b-table responsive :items="paymentHistory" :fields="paymentHistoryFields">
                      <template v-slot:cell(view_receipt)="data">
                        <span  v-html="data.value"></span>
                     </template>
                    </b-table>
                  </b-card>
                </b-tab>

                <b-tab title="Consumption History" @click="getConsumptionHistory('click')" >
                  <b-card
                   title="Consumption History"
                   style="   box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                   class="mb-2"
                   >
                   <b-row style="padding-bottom:20px;text-align:center">
                     <b-col cols=12>
                       Consumer No: <select class="customSelect" id="consList4" @change="getConsumptionHistory('change')"> </select>
                     </b-col>
                   </b-row>
                   <b-row>
                     <b-col col cols='12' sm="12" md="12" lg="6" id="chartContainer">
                         <canvas id="consumptionChart"></canvas>
                     </b-col>
                     <b-col class="marginTop" col cols='12' sm="12" md="12" lg="6">
                       <b-table responsive striped :items="consumptionHistory" :fields="consumptionHistoryFields">
                         <template v-slot:cell(view_receipt)="data">
                           <span  v-html="data.value"></span>
                        </template>
                       </b-table>
                     </b-col>
                   </b-row>

                  </b-card>
                </b-tab>



                <b-tab title="TDS Adjustment Statement" @click="showTdsAdjustment('click')" >
                  <b-card
                   title="TDS(194Q) Adjustment Statement"
                   style="   box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                   class="mb-2"
                   >
                   <b-row style="padding-bottom:10px;text-align:center">
                     <b-col cols=12>
                       Consumer No: <select class="customSelect" id="consList6" @change="showTdsAdjustment('change')"> </select>
                     </b-col>
                   </b-row>

                    <b-table responsive :items="tdsAdjustment" :fields="tdsAdjustmentFields" style="font-size:0.8rem">
                      <template v-slot:cell(challan_link)="data">
                        <span  v-html="data.value"></span>
                     </template>
                    </b-table>
                  </b-card>
                </b-tab>
                </b-tabs>
              </div>
            </b-col>
          </b-row>
  </b-container>

  </b-overlay>
    <br>



    <b-button id="success-btn" @click="$bvModal.show('successModal')" hidden></b-button>
    <b-button id="failure-btn" @click="$bvModal.show('failureModal')" hidden></b-button>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="modalMsg" style="color:red">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
    </b-modal>


    <b-modal id="profilesuccessModal" centered  scrollable title="Profile Update" hide-footer>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
      </svg>
      <p class="success">Profile Successfully Updated !<br><br>
      <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage()" >OK</b-button>
      </p>
    </b-modal>

    <b-modal id="profilefailureModal" centered  scrollable title="Profile Update" hide-footer>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
      </svg>
      <p class="error">Profile Update Failed ! </p>

    </b-modal>

    <b-modal id="otpModal" centered no-close-on-esc  no-close-on-backdrop title="OTP Verification" hide-footer>
      <b-overlay
      :show="show1"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style=""
      variant="dark"
      id="loader"
    >
      Enter the OTP received in your mobile number :
      <b-form-input type="number" id="otp" ></b-form-input><br>
      <b-button class="btn" variant="primary" id="success-btn" @click="updateConsumer()" >Verify</b-button> &nbsp&nbsp
      <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()" >Resend OTP</b-button>
    </b-overlay>
    </b-modal>
    </div>

  </template>


  <script>
  import Chart from 'chart.js';
  import HeaderConsumer from '@/components/HeaderConsumer.vue'
  import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
  import Vue from 'vue'
  import Vuex from 'vuex'
  import axios from 'axios'
var CryptoJS = require("crypto-js");
  var checked = 0;
  var thColor = '#0288d1';
  var oldMob="";
  var click = [];
  Vue.use(Vuex)
  //const urlCommon = "http://localhost:8081/website";
//  const urlCommon = "https://www.apdcl.org/website";

  export default {
    name: 'ConsumerDashboard',
    components: {

      'HeaderConsumer' : HeaderConsumer,
      'HeaderConsumerMobile' : HeaderConsumerMobile
      //MarqueeText

    },
    data() {
        return {
            show: false,
            show1: false,
            messageToSend:"",
            reqUrl:"",
            selected: null,
          consumerBillFields: [
            { key: 'bill_no', label: 'Bill Number',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'bill_date', label: 'Bill Date',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'due_date', label: 'Due Date',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'due_amt', label: 'Due Bill Amount',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px',textAlign:'center'} },
            { key: 'net_amt', label: 'Net Bill Amount',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px',textAlign:'right'} },
            { key: 'link', label: 'Download',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px',textAlign:'center'} }
          ],
          consumerBill : [],
          paymentHistoryFields: [
            { key: 'paid_bill_no', label: 'Bill Number',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'payment_date', label: 'Payment Date',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'payment_amt', label: 'Paid Amount',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'payment_mode', label: 'Payment Mode',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'tr_id', label: 'Receipt No',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'view_receipt', label: 'View',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
          ],
          paymentHistory : [],
          consumptionHistoryFields: [
            { key: 'meter_reading_date', label: 'Meter Reading Date',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'last_meter_reading', label: 'Last Meter Reading',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'consumption', label: 'Consumption (KWH)',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'total_days', label: 'Total Days',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
            ],
          consumptionHistory : [],
          consList:[],
          consDetails:[],
          tdsAdjustmentFields: [
            { key: 'sl_no', label: 'SL No',thStyle: {width: '3vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'cons_no', label: 'Consumer No',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'tan_no', label: 'TAN No',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'bill_no', label: 'Bill No',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'tds_amt', label: 'TDS Amount',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'challan_no', label: 'Challan No',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'challan_date', label: 'Challan Date',thStyle: {width: '7vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'challan_amt', label: 'Challan Amount',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'upload_date', label: 'Upload Date',thStyle: {width: '7vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'processed_flag', label: 'Processed',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'processed_date', label: 'Processed Date',thStyle: {width: '7vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'challan_link', label: 'Challan Link',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }

          ],
            tdsAdjustment:[],

          message : [
            "",
            "No Consumer Found for this Consumer Number",
            "No Outstanding Bill Found for this Consumer Number",
            "This Consumer Number is Blocked",
            "No Bill Found for Payment",
            "",
            "Server Busy! Kindly Try Again After Sometime.",
            "Transaction Already in Progress",
            "Error in Initiating Payment Request with Billdesk"
          ]
        }
    },

    methods:
    {
      closeModal(){
        this.$bvModal.hide('model')
      },
      reloadPage()
      {
        window.location.reload();
      },
      showBill()
      {

        var consNo = document.getElementById('consList1').value;
        var parent=this;
        this.show= true;
        axios.post(this.$urlArms+'/RestAPI/OnlinePayment/consBillDetailsBilldesk?consumerNo='+consNo)
        .then((response) => {
          parent.show= false;
          console.log(response.data);
          var data=response.data.data;
          var msg=response.data.message;
          if(msg=="00") {
            var res=data.due_date.split("-");
            var dueDate= res[2]+"-"+res[1]+"-"+res[0];
            document.getElementById("billDiv").style.display="block";
            document.getElementById("msgDiv").style.display="none";
            document.getElementById("sdCode").value = data.sd_code;
            document.getElementById("billAmt").innerHTML=data.due_amount+".00";
            document.getElementById("dueDate").innerHTML=dueDate;

          }
          else
          {
            document.getElementById("billDiv").style.display="none";
            document.getElementById("msgDiv").style.display="block";
            document.getElementById("msg").innerHTML=parent.message[parseInt(msg)];

          }
        })
        .catch((e) => {
          parent.show= false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Sorry, Please Try Again Later";
          console.log("Caught :::::::::::::::", e.message);

      })
      },
      payNow()
      {
        var consNo = document.getElementById("consList1").value;
        var sdCode = document.getElementById("sdCode").value;

        document.getElementById("consBillDiv").style.display="none";
        document.getElementById("billdeskRequestDiv").style.display="block";
        var parent= this;
        axios.post( this.$urlCommon+'/api/onlinepostpaid/pgrequest?consNo='+consNo+'&subDiv='+sdCode)
        .then((response) => {
          console.log(response.data);
          var data=response.data;
          var msg=response.data.message;

          if(msg=="00") {
            parent.reqUrl = data.action;
            parent.messageToSend= data.msg;
            setTimeout(function(){ document.getElementById("submit").click(); }, 2000);
          }
          else
          {
            document.getElementById('spinner').style.display = 'none';
            document.getElementById('errorDiv').style.display = 'block';
            document.getElementById('errorMsg').innerHTML = parent.message[parseInt(status)];
            this.$bvModal.show("model");
            document.getElementById("modalMsg").innerHTML=parent.message[parseInt(status)];
            //document.getElementById("BillDetails").classList.remove("showBillDetails");
          }


        })
        .catch((e) => {
          parent.show= false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Sorry, Please Try Again Later";
          console.log("Caught :::::::::::::::", e.message);

      })

      },
      getBillHistory(action)
      {

        if((action=="change")||( action=="click" && this.consumerBill.length==0))
         {
           var consNo = document.getElementById("consList2").value;
           this.show=true;
           var parent =this;
        axios.post('https://www.apdcl.org/armsPdfEngine/RestAPI/OnlineBill/billData?consNo='+consNo+'&billCount=6')
        .then((response) => {
        //console.log(response.data);
        this.show=false;
        var temp = [];
          response.data.forEach(element => {
                var res1= element.bill_DATE.split("-");
                var billDateFormatted = res1[2]+"/"+res1[1]+"/"+res1[0];
                var res2= element.due_DATE.split("-");
                var dueDateFormatted = res2[2]+"/"+res2[1]+"/"+res2[0];
                var dueAmt="";
                if(element.due_AMOUNT==0)
                  dueAmt="Paid";
                  else
                      dueAmt=element.due_AMOUNT+".00";

                var obj = {
                "bill_no":element.bill_NO,
                "bill_date":billDateFormatted,
                "due_date":dueDateFormatted,
                "due_amt":""+dueAmt+"<span>",
                "net_amt":""+element.net_AMOUNT+".00<span>",
                "link": "<a style='padding-left:35%' target='_blank' href='"+element.pdf_URL+"'><img src='"+parent.$urlCommon+"/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
            }
            temp.push(obj)

        })
        console.log(temp)
        parent.consumerBill = temp
      })
      .catch((e) => {
        parent.show= false;
        parent.$bvModal.show('model');
        document.getElementById("modalMsg").innerHTML="Sorry, Please Try Again Later";
        console.log("Caught :::::::::::::::", e.message);

    })
  }
    },
    getPaymentHistory(action)
    {
      if((action=="change")||( action=="click" && this.paymentHistory.length==0))
      {
      var consNo = document.getElementById("consList3").value;
      var parent = this;
      this.show=true;
      axios.post(this.$urlArms+'/RestAPI/PaymentReceipt?consNo='+consNo+'&noOfBills=6')
      .then((response) => {
      console.log(response.data);
      this.show=false;
      var data= response.data;
      var temp = [];
        data.forEach(element => {
              var res1= element.payment_DATE.split("-");
              var paymentDateFormatted = res1[2]+"/"+res1[1]+"/"+res1[0];


              var obj = {
              "paid_bill_no":element.bill_NO,
              "payment_date":paymentDateFormatted,
              "payment_amt":element.paid_AMOUNT+".00",
              "payment_mode":element.payment_MODE,
              "tr_id":element.receipt_NO,
              "view_receipt": "<a style='padding-left:40%' target='_blank' href='"+element.receiptlink+"'><img src='"+parent.$urlCommon+"/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
          }
          temp.push(obj)

      })
      console.log(temp)
      parent.paymentHistory = temp;

    })
    .catch((e) => {
      parent.show= false;
      parent.$bvModal.show('model');
      document.getElementById("modalMsg").innerHTML="Sorry, Please Try Again Later";
      console.log("Caught :::::::::::::::", e.message);

  })
}
  },
  getConsumptionHistory(action)
  {

    if((action=="change")||( action=="click" && this.consumptionHistory.length==0))
    {
    var chartData = [];
    var chartLabel = [];
    var consNo = document.getElementById("consList4").value;
    this.show=true;
    var parent = this;
    axios.post(this.$urlArms+'/RestAPI/OnlinePortal/consumptionHistory?consNo='+consNo)
    .then((response) => {
    console.log(response.data);
    parent.show=false;
    var temp = [];
      response.data.response.forEach(element => {
            var res1= element.meter_READING_DATE.split("-");
            var meterREADINGDATE = res1[2]+"/"+res1[1]+"/"+res1[0];

            var obj = {
            "meter_reading_date":meterREADINGDATE,
            "last_meter_reading":element.last_METER_READING,
            "consumption":element.consumption,
            "total_days":element.no_OF_DAYS,
            }
        temp.push(obj);
        chartData.push(element.consumption);
        chartLabel.push(meterREADINGDATE);

    })
    console.log(temp)
    parent.consumptionHistory = temp;

    document.getElementById("chartContainer").innerHTML = '&nbsp;';
    document.getElementById("chartContainer").innerHTML = '<canvas id="consumptionChart"></canvas>';
    var ctx = document.getElementById('consumptionChart');
    var myChart = new Chart(ctx, {
      type: 'bar',
      data: {
      labels: chartLabel,
      datasets: [
        {
            label	: "Consumption",
            fill: true,
            backgroundColor: [
                '#ffab91',
                '#ff8a65',
                '#ff7043',
                '#ff5722',
                '#e64a19',
                '#d84315'
                ],
            data: chartData
        }
    ]
  } ,

  options: {
       responsive: true,
       lineTension: 1,
       scales: {
         yAxes: [{
           ticks: {
             beginAtZero: true,
             padding: 25,
           }
         }]
       }
     }
   });
  })
  .catch((e) => {
    parent.show= false;
    parent.$bvModal.show('model');
    document.getElementById("modalMsg").innerHTML="Sorry, Please Try Again Later";
    console.log("Caught :::::::::::::::", e.message);

})
}
},
showConsDetails(action)
{

  if((action=="change")||( action=="click" && this.consDetails.length==0))
  {
  var consNo = document.getElementById('consList5').value;
  this.show= true;
  var parent=this;
  axios.post(this.$urlArms+'/RestAPI/myBijulee/ConsDetails?cons_no='+consNo)
  .then((response) => {
    parent.show= false;
    console.log(response.data);
    var data=response.data;
    oldMob = data.mobile_no;
    document.getElementById("consumerNumber").innerHTML = data.cons_no;
    document.getElementById("consumerName").innerHTML = data.cons_name;
    document.getElementById("mobile").value = data.mobile_no;
    document.getElementById("email").value = data.email;
    parent.selected = data.occupation;
    if (data.aadhar_NO== null || data.aadhar_NO=="")
    document.getElementById("aadhaar").placeholder = "Enter Aadhar No";
    else
    document.getElementById("aadhaar").placeholder = "UPDATED";
    parent.consDetails.push(data.cons_no);
  })
  .catch((e) => {
  console.log("Caught", e);
  parent.show= false;
  parent.$bvModal.show("model");
  document.getElementById("modalMsg").innerHTML="Sorry, Try Again Later";

})
}
},
showTdsAdjustment(action)
{
  if((action=="change")||( action=="click" && this.tdsAdjustment.length==0))
  {
  var consNo = document.getElementById("consList6").value;
  var parent = this;
  this.show=true;
  //axios.get('http://localhost:8081/cbs/RestAPI/OnlinePortal/tdsStatement?consNo=080000002207')
  axios.get(this.$urlArms+'/RestAPI/OnlinePortal/tdsStatement?consNo='+consNo)
  .then((response) => {
  console.log(response.data.tdsStatement);
  this.show=false;
  var status= response.data.status;
  var data= response.data.tdsStatement;
  var temp = [];
  var i =1;
  if(status==="Success")
  {
    data.forEach(element => {
          // var res1= element.payment_DATE.split("-");
          // var paymentDateFormatted = res1[2]+"/"+res1[1]+"/"+res1[0];
          var processedDate = "---"
          if(element.processed_DATE!=null)
            processedDate=element.processed_DATE.split("T")[0];
          var uploadDate = "---"
            if(element.upload_DATE!=null)
              uploadDate=element.upload_DATE.split("T")[0];
          var obj = {
          "sl_no": i++,
          "cons_no":element.cons_NO,
          "tan_no":element.tan_NO,
          "bill_no":element.bill_NO,
          "tds_amt":element.tds_AMT_DEDUCTED,
          "challan_no":element.challan_NO,
          "challan_date":element.challan_DATE,
          "challan_amt":element.challan_AMT,
          "upload_date":uploadDate,
          "processed_flag":element.processed_FLAG,
          "processed_date":processedDate,
          "challan_link": "<a style='padding-left:40%' target='_blank' href='"+element.challan_LINK+"'><img src='"+parent.$urlCommon+"/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
      }
      temp.push(obj);
  })

  parent.tdsAdjustment = temp;

  }
  else {
    parent.$bvModal.show('model');
    document.getElementById("modalMsg").innerHTML=response.data.message;

  }


})
.catch((e) => {
  parent.show= false;
  parent.$bvModal.show('model');
  document.getElementById("modalMsg").innerHTML="Sorry, Please Try Again Later";
  console.log("Caught :::::::::::::::", e.message);

})
}
},
sendOtp()
{
  var parent =this;
  var mobile = document.getElementById("mobile").value;
  var occupation = document.getElementById("occupation").value;
  var email = document.getElementById("email").value;
  var aadhaar = document.getElementById("aadhaar").value;

  var mobregx = /^[5-9]\d{9}$/
  if(!mobregx.test(mobile))
    {
      // document.getElementById('failure-btn-mob').click();
      this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
        title: `Alert`,
        variant: 'danger',
        solid: true
      })
    return
    }
    var emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if(!emailRegex.test(email) && email!="")
      {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Enter Valid Email !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("email").focus();
      return
      }
      if(occupation=="null")
        {
          // document.getElementById('failure-btn-mob').click();
          this.$bvToast.toast('Please Select Your Occupation !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
            document.getElementById("occupation").focus();
        return
        }
        var aadhaarRegex =  /^\d{12}$/;
        if(!aadhaarRegex.test(aadhaar) && aadhaar!="" )
          {
            // document.getElementById('failure-btn-mob').click();
            this.$bvToast.toast('Enter Valid 12 digit Adhaar Number !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("aadhaar").focus();
          return
          }

  parent.show= true;
  axios.post(this.$urlCommon+"/api/generateOtp?mobNo="+mobile).then(function(response) {
    console.log(response.data);
    parent.show= false;
    if (response.data.message == "success") {
      parent.$bvToast.toast('OTP Sent Successfully !', {
        title: `Success`,
        variant: 'success',
        solid: true
      });
      parent.$bvModal.show('otpModal');
  //    document.getElementById("mobileNo").disabled=true;

    }
  });
},
resendOtp()
{
  var parent =this;
  var mobile = document.getElementById("mobile").value;
  parent.show1= true;
  axios.post(this.$urlCommon+"/api/reGenerateOtp?mobNo="+mobile).then(function(response) {
    parent.show1= false;
    if (response.data.message == "success") {
      parent.$bvToast.toast('OTP Sent Successfully !', {
        title: `Success`,
        variant: 'success',
        solid: true
      });
    }
  else {
      parent.$bvToast.toast('OTP Could not Sent !', {
        title: `danger`,
        variant: 'danger',
        solid: true
      });
    }
  });
},
updateConsumer(){

  var consNo = document.getElementById("consList5").value;
  var mobNo = document.getElementById("mobile").value;
  var email = document.getElementById("email").value;
  var otp = document.getElementById("otp").value;
  var occupation = document.getElementById("occupation").value;
  var aadhaar = document.getElementById("aadhaar").value;
  var encAdhar = this.encryptAadhar(aadhaar);
  console.log("Aadhaar : "+aadhaar)
  console.log("Encrypted Aadhaar : "+encAdhar)
  this.show= true;
  var parent = this;

  console.log(mobNo+"::::"+oldMob+":::"+email+"::::"+consNo+":::"+occupation+"::::"+aadhaar);
  if(otp=="")
    {
      // document.getElementById('failure-btn-mob').click();
      this.$bvToast.toast('Enter OTP !', {
        title: `Alert`,
        variant: 'danger',
        solid: true
      })
    return
    }

    this.show1= true;
  //  console.log(consNo+"::"+consName+"::"+connType+"::"+mobNo+"::"+email+"::")
      axios.post(this.$urlCommon+"/api/validateOtp?mobNo="+mobNo+"&otpNo="+otp).then(function(response) {
        console.log(response.data);
          if (response.data.message == "VALID") {

            parent.$bvToast.toast('OTP Successfully Verified !', {
            title: `Error`,
            variant: 'success',
            solid: true
          });
      axios.post(parent.$urlCommon+"/myBijulee/updateConsumerDetails?consNo="+consNo+"&mobNo="+mobNo+"&oldMobNo="+oldMob+"&email="+email+"&aadhaar="+encAdhar+"&occupation="+occupation)
      .then(function(response) {
      console.log(response.data);
      parent.show1= false;
      parent.show= false;
      var msg=response.data.msg;
      if(msg=="00") {
        parent.$bvModal.hide('otpModal');
      parent.$bvModal.show('profilesuccessModal');
}
else
{
  parent.$bvModal.hide('otpModal');
parent.$bvModal.show('profilefailureModal');
}
})
.catch((e) => {
  parent.show= false;
  parent.$bvModal.show('model');
  document.getElementById("modalMsg").innerHTML="Sorry, Please Try Again Later";
  console.log("Caught :::::::::::::::", e.message);
})
}
else {
  parent.show1= false;
  parent.$bvModal.show('model');
  document.getElementById("modalMsg").innerHTML="Invalid OTP";
}
})
},
encryptAadhar(plaintext){
    var encryptedAES = CryptoJS.AES.encrypt(plaintext, "U@M@A&N#G$-A#P%d&u@c-h1_e@r$r%l#");
    console.log("ct: " + encryptedAES);
    return encryptedAES;
  }
},
    mounted()
    {

      // var url_string = window.location.href;
      // var url = new URL(url_string);
      // var mobile = url.searchParams.get("mobileNo");
      var mobile = "";
      let name = "mobile=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          mobile= c.substring(name.length, c.length);
          console.log(mobile);
        }
      }
      if(mobile=="")
        {
          this.$router.push({ path: '/' })
          return;
        }

      // var mobileNo = localStorage.getItem("mobileNo");
      // console.log("mobile 1:"+mobile+"####mobile 2:"+mobileNo);
      // if(mobileNo != mobile)
      //   {
      //     this.$router.push({ path: '/' })
      //     return;
      //   }

      document.getElementById("consName").innerHTML=mobile;
      document.getElementById("consNameMb").innerHTML=mobile;
      var temp=[];
      parent=this;
        this.show= true;
      axios.post(this.$urlCommon+"/myBijulee/fetchConsumer?mobile_no="+mobile).then(function(response) {
      console.log(response.data);
      if(response.data.message =="success")
      {
        parent.show= false;
        response.data.consList.forEach(element => {
        temp.push(element);
        var option1 = document.createElement("option");
       	option1.text = element;
       	option1.value = element;
       	var select1 = document.getElementById("consList1");
       	select1.appendChild(option1);

        var option2 = document.createElement("option");
        option2.text = element;
        option2.value = element;
        var select2 = document.getElementById("consList2");
        select2.appendChild(option2);

        var option3 = document.createElement("option");
        option3.text = element;
        option3.value = element;
        var select3 = document.getElementById("consList3");
        select3.appendChild(option3);

        var option4 = document.createElement("option");
        option4.text = element;
        option4.value = element;
        var select4 = document.getElementById("consList4");
        select4.appendChild(option4);

        var option5 = document.createElement("option");
        option5.text = element;
        option5.value = element;
        var select5 = document.getElementById("consList5");
        select5.appendChild(option5);

        var option6 = document.createElement("option");
        option6.text = element;
        option6.value = element;
        var select6 = document.getElementById("consList6");
        select6.appendChild(option6);
      })
        console.log(temp);
        parent.consList = temp;
      //  parent.showBill();
        parent.showConsDetails("change");

        /*
        axios.post('https://www.apdclrms.com/cbs/RestAPI/OnlinePayment/consBillDetailsTest?consumerNo='+temp[0])
        .then((response) => {
            parent.show= false;
            console.log(response.data);
            var data=response.data.data;
            var msg=response.data.message;
          if(msg=="00") {
            var res=data.due_date.split("-");
            var dueDate= res[2]+"-"+res[1]+"-"+res[0];
            document.getElementById("billDiv").style.display="block";
            document.getElementById("msgDiv").style.display="none";
            document.getElementById("sdCode").value = data.sd_code;
            document.getElementById("billAmt").innerHTML=data.due_amount+".00";
            document.getElementById("dueDate").innerHTML=dueDate;
          }
          else
          {
            document.getElementById("billDiv").style.display="none";
            document.getElementById("msgDiv").style.display="block";
            document.getElementById("msg").innerHTML=parent.message[parseInt(msg)];
          }
        })
        */
      }
      else {
        {  parent.show= false;
          document.getElementById("billDiv").style.display="none";
          document.getElementById("msgDiv").style.display="block";
          document.getElementById("msg").innerHTML="No Consumer Mapped to This Mobile number";
        }
      }
    })
    .catch((e) => {
      parent.show= false;
      parent.$bvModal.show('model');
      document.getElementById("modalMsg").innerHTML="Sorry, Please Try Again Later";
      console.log("Caught :::::::::::::::", e.message);

  })
  }
  }

  </script>


  <style scoped="true">

  .label{
  font-weight:600;
  }
  .customSelect
  {

  border: 1px solid #039be5 ;
  color: #0277bd    ;
  border-radius: 5px;
  height: 1.8rem;
  width: 10rem;
  font-weight: 600;

  }
  .customSelect:hover
  {
  cursor:pointer;
  border: 2px solid #039be5;
  color: #1565c0  ;
  border-radius: 5px;
  height: 1.8rem;
  width: 10rem;
  font-weight: 600;
  }
  .modalFont{
    width: 100px;
    display: block;
    margin: 40px auto 0;
  }

  .path {
    stroke-dasharray: 1000;
    stroke-dashoffset: 0;
  }
  .path.circle {
    -webkit-animation: dash 0.9s ease-in-out;
    animation: dash 0.9s ease-in-out;
  }
  .path.line {
    stroke-dashoffset: 1000;
    -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
    animation: dash 0.9s 0.35s ease-in-out forwards;
  }
  .path.check {
    stroke-dashoffset: -100;
    -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
    animation: dash-check 0.9s 0.35s ease-in-out forwards;
  }

  p {
    text-align: center;
    margin: 20px 0 60px;
    font-size: 1.25em;
  }
  p.success {
    color: #73AF55;
  }
  p.error {
    color: #D06079;
  }
  @-webkit-keyframes dash {
    0% {
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes dash {
    0% {
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @-webkit-keyframes dash-check {
    0% {
      stroke-dashoffset: -100;
    }
    100% {
      stroke-dashoffset: 900;
    }
  }
  @keyframes dash-check {
    0% {
      stroke-dashoffset: -100;
    }
    100% {
      stroke-dashoffset: 900;
    }
  }
  .headerF{
    display: block;
  }
  .headerM{
    display: none;
  }
  .OnlinePaymentCardStyle{
    padding:0;
    box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;
    width:30%;
    margin-left:35%;
    text-align:center;
    min-height:50vh;
  }
  .marginTop{
    margin-top: -10px;
  }
  .marginTop20px{
    margin-top: none;
  }
  @media (max-width: 768px) {
      .headerF{
        display: none;
      }
      .headerM{
        display: block;
      }
      .OnlinePaymentCardStyle{
        width:50%;
        margin-left:25%;
      }
      .marginTop{
        margin-top: 20px;
      }
      .marginTop20px{
        margin-top: 20px;
      }
    }
  @media (max-width: 576px) {
    .OnlinePaymentCardStyle{
      width:80%;
      margin-left:10%;
    }
    .marginTop20px{
      margin-top: 20px;
    }
  }
  </style>
